import React from 'react';
import styled from 'styled-components';
import {Image} from '../index';
import {ImageProps} from '../images';

const Logo = styled.li<{padding: number; maxWidth}>`
    display: inline-block;
    vertical-align: middle;
    position: relative;
    overflow: hidden;
    height: 100px;
    width: 120px;
    opacity: 1;
    margin-right: ${(p) => p.theme.spacing(5)}px;
    padding-right: ${(p) => p.padding}px;
    padding-left: ${(p) => p.padding}px;
    .image-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
    }
    img {
        object-position: 0;
        height: auto;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }
    ${(p) => p.theme.breakpoints.up('lg')} {
        height: 100px;
        width: ${(p) => (p.maxWidth > 160 ? `${p.maxWidth}px` : '160px')};
        margin-right: ${(p) => p.theme.spacing(6)}px;
        img {
            max-width: ${(p) => (p.maxWidth ? `${p.maxWidth}px` : '100px')};
            max-height: 100px;
        }
    }
    ${(p) => p.theme.breakpoints.down('lg')} {
        margin-right: ${(p) => p.theme.spacing(6)}px;
        height: 100px;
        width: ${(p) => (p.maxWidth > 160 ? `${p.maxWidth}px` : '160px')};
        img {
            max-width: ${(p) => (p.maxWidth ? `${p.maxWidth - 5}px` : '95px')};
            max-height: 95px;
        }
    }
    ${(p) => p.theme.breakpoints.only('md')} {
        width: ${(p) => (p.maxWidth > 160 ? `${p.maxWidth}px` : '160px')};
    }
    ${(p) => p.theme.breakpoints.down('sm')} {
        width: 160px;
    }
    ${(p) => p.theme.breakpoints.down('sm')} {
        margin-right: ${(p) => p.theme.spacing(2)}px;
        margin-bottom: ${(p) => p.theme.spacing(2)}px;
        height: 100px;
        width: 100px;
        img {
            max-width: ${(p) => (p.maxWidth ? `${p.maxWidth - 5}px` : '95px')};
            max-height: 95px;
        }
    }

    ${(p) => p.theme.breakpoints.down('xs')} {
        &:nth-child(3n) {
            margin-right: 0;
        }
    }
    ${(p) => p.theme.breakpoints.down('sm')} {
        &:nth-child(6n) {
            margin-right: 0;
        }
    }
`;

export const LogoItem = ({
    padding,
    maxWidth,
    ...image
}: ImageProps & {padding?: number; maxWidth?: number}): JSX.Element => {
    return (
        <Logo padding={padding || 0} maxWidth={maxWidth}>
            <Image {...image} disableRatioHelper={true} fit="contain" optMaxWidth={300} />
        </Logo>
    );
};
